import React from "react";
import CustomButton from "@/components/common/buttons/custom-button/custom-button";
import clsx from "clsx";

interface FormNavigationProps {
    onBack: () => void;
    submitText: string;
    onSubmit: () => void;
    isFirstStep: boolean;
    disabled?: boolean;
}

const FormNavigation = ({ onBack, submitText, onSubmit, isFirstStep, disabled }: FormNavigationProps) => {
    const handleSubmit = (e?: React.MouseEvent<HTMLButtonElement>) => {
        e?.preventDefault();
        onSubmit();
    };

    return (
        <div className="tw-flex tw-justify-between tw-gap-4">
            <CustomButton
                className="tw-flex-1 tw-bg-[#FFF7ED] tw-text-[#F69929] tw-rounded-[8px] tw-py-2 tw-font-semibold"
                text="Back"
                handleClick={onBack}
                type="button"
                id="back-button"
                dataCy="back-button"
            />
            <CustomButton
                className={clsx(
                    "tw-flex-1 tw-bg-[#F69929] tw-text-white tw-rounded-[8px] tw-py-2 tw-font-semibold",
                    disabled && "tw-opacity-50 tw-cursor-not-allowed",
                )}
                text={submitText}
                handleClick={handleSubmit}
                type="button"
                isDisabled={disabled}
                id="submit-button"
                dataCy="submit-button"
            />
        </div>
    );
};

export default FormNavigation;
